import React, { useEffect } from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { CalendarEventDto } from '@/types/calendar';
import { FormPayload } from './FeelingForm';

interface Props {
  disabled: boolean;
  eventToEdit?: CalendarEventDto | null;
  onChange: (payload: FormPayload) => void;
}

export const TaskForm: React.FC<Props> = ({ disabled, eventToEdit, onChange }) => {
  const [title, setTitle] = React.useState('');
  const [notes, setNotes] = React.useState('');
  const [priority, setPriority] = React.useState<'low' | 'medium' | 'high'>('medium');

  useEffect(() => {
    setTitle(eventToEdit?.title ?? '');
    setNotes(eventToEdit?.details?.notes ?? '');
    setPriority(eventToEdit?.details?.priority ?? 'medium');
  }, [eventToEdit]);

  useEffect(() => {
    onChange({
      title,
      details: { notes, priority },
      isValid: title.trim().length > 0,
    });
  }, [title, notes, priority]);

  return (
    <>
      <TextField
        autoFocus
        margin="dense"
        label="Назва завдання"
        fullWidth
        variant="outlined"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        disabled={disabled}
      />
      <TextField
        margin="dense"
        label="Нотатки"
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        disabled={disabled}
      />
      <FormControl fullWidth margin="dense" variant="outlined" disabled={disabled}>
        <InputLabel>Пріоритет</InputLabel>
        <Select
          value={priority}
          onChange={(e) => setPriority(e.target.value as 'low' | 'medium' | 'high')}
          label="Пріоритет"
        >
          <MenuItem value="low">Низький</MenuItem>
          <MenuItem value="medium">Середній</MenuItem>
          <MenuItem value="high">Високий</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};
